const SECTION_LABELS = {
  executiveSummary: "Executive summary",
  transportAccess: "Transport access",
  scorecard: "Neighborhood mobility scorecard",
  metroBus: "Metro and bus coverage",
  ridership: "Ridership pressure",
  disruptions: "Disruption and risk signals",
  communityReports: "Community mobility reports",
  roads: "Road incidents and closures",
  sourceHealth: "Source health and freshness",
  methodology: "Methodology",
  disclaimers: "Disclaimers",
  attribution: "Source attribution",
  scorecardHighlights: "Scorecard highlights",
  marketAccess: "Market access distribution",
  marketScorecards: "Market scorecards",
};

function renderSection(key, section) {
  if (!section || typeof section !== "object") return null;
  if (section.notEnoughData) {
    return (
      <section className="panel-card transport-report-section" key={key}>
        <h3>{SECTION_LABELS[key] || key}</h3>
        <p className="muted">{section.message || "Not enough data available for this section."}</p>
      </section>
    );
  }

  if (key === "disclaimers" && Array.isArray(section)) {
    return (
      <section className="panel-card transport-report-section" key={key}>
        <h3>Disclaimers</h3>
        <ul>
          {section.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>
    );
  }

  if (key === "attribution" && Array.isArray(section)) {
    return (
      <section className="panel-card transport-report-section" key={key}>
        <h3>Source attribution</h3>
        <ul>
          {section.map((item) => (
            <li key={item.sourceKey}>
              <strong>{item.displayName}</strong> — {item.sourceType}
              {item.attributionText ? ` — ${item.attributionText}` : ""}
            </li>
          ))}
        </ul>
      </section>
    );
  }

  if (key === "executiveSummary") {
    return (
      <section className="panel-card transport-report-section" key={key}>
        <h3>Executive summary</h3>
        <p>{section.text}</p>
      </section>
    );
  }

  return (
    <section className="panel-card transport-report-section" key={key}>
      <h3>{SECTION_LABELS[key] || key}</h3>
      <pre className="transport-report-pre">{JSON.stringify(section, null, 2)}</pre>
    </section>
  );
}

const TransportReportView = ({ report }) => {
  const payload = report?.reportPayload || {};
  const sections = payload.sections || {};
  const warnings = [...(report?.warnings || []), ...(payload.warnings || [])];

  return (
    <div className="transport-report-view">
      <header className="transport-report-view__header">
        <p className="crm-home__eyebrow">Midpoint Mobility Intelligence Report</p>
        <h1>{report?.title}</h1>
        <p className="muted">
          Generated {report?.generatedAt ? new Date(report.generatedAt).toLocaleString() : "—"}
        </p>
        {payload.meta?.clientViewName ? (
          <p className="muted">Client View: {payload.meta.clientViewName}</p>
        ) : null}
        {report?.summaryText ? <p>{report.summaryText}</p> : null}
      </header>

      {warnings.length ? (
        <section className="panel-card transport-report-section">
          <h3>Warnings</h3>
          <ul>
            {warnings.map((warning, index) => (
              <li key={`${warning.code || "warn"}-${index}`}>{warning.message || warning.code}</li>
            ))}
          </ul>
        </section>
      ) : null}

      {Object.entries(sections).map(([key, section]) => renderSection(key, section))}
    </div>
  );
};

export default TransportReportView;
